import { useTranslations } from 'next-intl'

import classnames from 'classnames'

import Image from '~/components/atoms/Image/Image'
import Link from '~/components/atoms/Link/Link'
import SpecificImage from '~/components/atoms/SpecificImage/SpecificImage'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import firstLettersConcatenated from '~/utils/firstLetterConcatenated'

import styles from './ArticleAuthor.module.css'

export interface ArticleAuthorProps {
  author: {
    name: string
    slug: string
    image: any
  }
  clickEvent?: any
  centered?: boolean
  showDefault?: boolean
  preText?: string
  size?: 'default' | 'small'
}

export default function ArticleAuthor({
  author,
  clickEvent,
  centered = true,
  showDefault = true,
  preText,
  size = 'default',
}: ArticleAuthorProps) {
  const t = useTranslations('common')
  const authorsName = author?.name ? author.name : 'Erin Argun'
  const defaultPreText = preText || t('writtenBy')
  const usePreText = !author?.name ? t('reviewedBy') : defaultPreText

  if (!showDefault && !author?.name) return null

  const imageSize = size === 'small' ? 20 : 60

  return (
    <Link
      href={author?.slug ? author?.slug : '/team/erin-atlanta-argun'}
      onClick={clickEvent && clickEvent}
      noPrefetch
    >
      <div
        className={classnames(
          styles.author,
          centered && styles.authorCentered,
          {
            [styles.authorSmall]: size === 'small',
            [styles.authorDefault]: size === 'default',
          }
        )}
      >
        <div
          className={classnames(
            styles.avatar,
            size === 'small' && styles.avatarSmall
          )}
        >
          {!author && (
            <Image asset="https://cdn.sanity.io/images/dqllnil6/production/60496f739545b9cdc6d070b592b1162f675c5c59-1575x1912.png?w=64&q=60&auto=format" />
          )}
          {author?.image?.asset ? (
            <SpecificImage
              asset={author.image.asset}
              alt={author.name}
              width={imageSize}
            />
          ) : (
            <div className={styles.intialsFallback}>
              <Text size={TextSizes.secondaryTitleMicro}>
                {firstLettersConcatenated(authorsName)}
              </Text>
            </div>
          )}
        </div>
        <Text size={TextSizes.magPrimaryTitleSml} className={styles.expert}>
          <em>{usePreText}</em> {authorsName}
        </Text>
      </div>
    </Link>
  )
}
